import React from "react";

function GeneralLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full min-w-[300px] min-h-[100vh] flex items-center justify-center overflow-x-hidden">
      <div className="w-full h-full min-h-full max-w-[2000px] shadow-lg overflow-x-auto">
        {children}
      </div>
    </div>
  );
}

export default GeneralLayout;
